<template>
  <div>
    <div class="common-style books">
      <div class="bookTerm">
        <div>
          <a-select
            v-model="listInfo.range"
            style="width: 100%"
            placeholder="请选择来源"
            allowClear
            @change="changeRange"
          >
            <a-select-option v-for="item in sourceInfo" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </div>
        <div class="stage">
          <a-select
            mode="multiple"
            v-model="listInfo.stageIds"
            :maxTagCount="4"
            style="width: 100%"
            allowClear
            notFoundContent="暂无数据"
            placeholder="请选择学段"
            @change="changeStages"
          >
            <a-select-option
              v-for="(item, index) in stagesList"
              :key="index"
              :value="index"
            >{{ item }}</a-select-option>
          </a-select>
        </div>
        <div class="grade">
          <a-select
            mode="multiple"
            allowClear
            :maxTagCount="3"
            v-model="listInfo.gradeIds"
            style="width: 100%"
            @change="changeGrades"
            notFoundContent="暂无数据"
            placeholder="请选择年级"
          >
            <a-select-option
              v-for="(item, index) in gradesList"
              :key="index"
              :value="index"
            >{{ item }}</a-select-option>
          </a-select>
        </div>

        <div style="color:bule">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <span
                style="padding:0.5em 1.5em;border:1px solid #409eff;border-radius:5px"
              >管&nbsp;&nbsp;控</span>
            </a>
            <a-menu slot="overlay" v-if="classMasterInfoList.length > 0">
              <a-menu-item v-for="(item, index) in classMasterInfoList" :key="index">
                <div v-if="classMasterInfoList.length > 0" style="height:2em;line-height:2em">
                  <span>是否允许学生查看：</span>
                  <span v-show="classMasterInfoList.length > 1">
                    {{
                    item.classname
                    }}
                  </span>
                  <a-tooltip>
                    <template slot="title" v-if="!item.ismaster">
                      <span>非班主任没有此权限</span>
                    </template>
                    <span class="roles-waitch">
                      <a-switch
                        :checked="item.isEnable"
                        size="small"
                        :disabled="!item.ismaster"
                        @change="changeAble(item)"
                      />
                    </span>
                  </a-tooltip>
                </div>
              </a-menu-item>
            </a-menu>
            <a-menu slot="overlay" v-else>
              <a-menu-item>您当前暂无权限放开图书</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
      <div class="teach-list">
        <ul v-if="!noData">
          <li class="lifirstAdd" @click="addBooks(false)">+添加图书</li>
          <li v-for="(item, index) in bookList" :key="index">
            <div class="books-tip">
              <div
                class="books-tip-item"
                :class="item.orgid > 0 ? 'bg_green' : 'bg_orange'"
              >{{ item.orgid > 0 ? "自主上传" : "系统内置" }}</div>
              <div>
                <img :src="item.coverLink" />
              </div>
              <div class="dv dv1">
                <a-tooltip>
                  <template slot="title">{{ item.bookName }}</template>
                  <i>{{ item.bookName }}</i>
                </a-tooltip>
                <span>
                  <a-dropdown placement="bottomRight" :trigger="['click']">
                    <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                      <a-icon type="more" />
                    </a>
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <span class="edit" @click="addBooks(true, item)">编辑</span>
                      </a-menu-item>
                      <a-menu-item>
                        <span class="del" @click="del(item)">删除</span>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </span>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="noData" class="noData">
          <p>
            <img src="../../assets/images/noData.png" alt />
          </p>
          <a-button type="primary" @click="addBooks(false)">添加图书</a-button>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pagination" v-if="paginShow">
        <a-pagination
          size="small"
          :total="rowCount"
          :showTotal="(total) => `总 ${total} 份`"
          :pageSize.sync="pagination.pageSize"
          v-model="pagination.page"
          @change="onChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bookList: [],
      rowCount: "",
      loadingList: true,
      pagination: {
        page: 1,
        pageSize: 11,
      },
      listInfo: {
        range: -1, // 来源
        stageIds: [], //学段
        gradeIds: [], //年级
      },
      stagesList: {},
      gradesList: {},

      paginShow: false,
      noData: true,
      isEnable: "",
      classMasterInfoList: [],
      sourceInfo: [
        {
          id: -1,
          name: "全部图书",
        },
        {
          id: 0,
          name: "系统内置",
        },
        {
          id: 1,
          name: "自主上传",
        },
      ],
    }
  },
  methods: {
    // 学段联动接口
    getAllselect () {
      this.$http
        .get("v1/learnonly/teachingAssistant/showVerGreSubSta", {
          params: {
            userid: this.$store.getters.id,
            stageid: "",
            subjectid: "",
          },
        })
        .then((response) => {
          // console.log(response)
          response.data.stage["0"] = "全部学段" //默认显示全部
          response.data.grade["0"] = "全部年级" //默认显示全部
          this.listInfo.stageIds.push("0")
          this.listInfo.gradeIds.push("0")
          this.stagesList = response.data.stage
          this.gradesList = response.data.grade
        })
    },

    changeRange (value) {
      console.log(value)
      this.listInfo.range = value
      this.pagination.page = 1
      this.getBooklist()
    },

    changeGrades (value) {
      this.pagination.page = 1
      let flag = value.some((item) => {
        return item == 0
      })

      let index = value.findIndex((item) => {
        return item == "0"
      })

      if (index == 0) {
        if (value.length == 1) {
          this.listInfo.gradeIds = "0"
        } else {
          let arr = value.filter((item) => {
            return item > 0
          })
          this.listInfo.gradeIds = arr
        }
      } else {
        if (flag) {
          this.listInfo.gradeIds = "0"
        } else {
          this.listInfo.gradeIds = value
        }
      }
      this.getBooklist()
    },

    changeStages (value) {
      // console.log(value)
      // this.pagination.page = 1
      // let flag = value.every((item) => {
      //   return item == 0
      // })

      // if (flag) {
      //   //数组中只有全部选项
      //   this.listInfo.stageIds = value
      // } else {
      //   let arr = value.filter((item) => {
      //     return item > 0
      //   })
      //   this.listInfo.stageIds = arr
      // }
      // this.getBooklist()

      this.pagination.page = 1
      let flag = value.some((item) => {
        return item == 0
      })

      let index = value.findIndex((item) => {
        return item == "0"
      })

      if (index == 0) {
        if (value.length == 1) {
          this.listInfo.stageIds = "0"
        } else {
          let arr = value.filter((item) => {
            return item > 0
          })
          this.listInfo.stageIds = arr
        }
      } else {
        if (flag) {
          this.listInfo.stageIds = "0"
        } else {
          this.listInfo.stageIds = value
        }
      }
      this.getBooklist()
    },

    // 获取图书列表
    getBooklist () {
      this.$http
        .post("/v1/books/lists", {
          teacherId: this.$store.getters.id,
          range: this.listInfo.range != undefined ? this.listInfo.range : -1,
          stageIds:
            this.listInfo.stageIds.includes("0") ||
              this.listInfo.stageIds.length == 0
              ? -1
              : this.listInfo.stageIds,
          gradeIds:
            this.listInfo.gradeIds.includes("0") ||
              this.listInfo.gradeIds.length == 0
              ? -1
              : this.listInfo.gradeIds,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
        })
        .then((res) => {
          if (res.data.resultList.length !== 0) {
            this.bookList = res.data.resultList
            this.rowCount = res.data.totals
            // this.isEnable = res.data.isEnable
            this.classMasterInfoList.forEach((item) => {
              if (res.data.isEnableMap.length > 0) {
                res.data.isEnableMap.forEach((element) => {
                  if (item.classid == element.classId) {
                    item.isEnable = element.isEnable
                  }
                })
              } else {
                item.isEnable = false
              }
            })
            this.noData = false
            this.$nextTick(() => {
              this.paginShow = true
            })
          } else {
            this.noData = true
            this.paginShow = false
          }
        })
    },
    // 分页
    onChange (page, pageSize) {
      this.pagination.page = page
      this.pagination.pageSize = pageSize
      this.getBooklist()
    },
    // 开关
    changeAble (item) {
      console.log(item)
      item.isEnable = !item.isEnable
      this.$forceUpdate()
      this.$http
        .post("/v1/books/updateEnable", {
          teacherId: this.$store.getters.id,
          classId: item.classid,
          isEnable: item.isEnable,
        })
        .then((res) => {
          console.log(res)
          res.data.code == 200
            ? this.$message.success("设置成功", 1)
            : this.$message.error(res.data.message, 1)
        })
    },

    //添加图书
    addBooks (state, item) {
      if (state) {
        // console.log(item)
        // 编辑
        // 判断这个账号是不是管理员账号以及判断这个是不是自主上传的图书 orgid为0是系统内置的图书
        if (!this.$store.getters.roles.includes("admin")) {
          if (item.orgid == 0) {
            // 系统内置
            return this.$message.info("非管理员账号只能编辑本机构下的图书!", 1)
          }
        }

        this.$router.push({
          path: "/books/addBooks",
          query: { type: true, books: JSON.stringify(item) },
        })
      } else {
        //添加
        this.$router.push({
          path: "/books/addBooks",
          query: {
            type: false,
          },
        })
      }
    },

    // 删除
    del (item) {
      // 判断这个账号是不是管理员账号以及判断这个是不是自主上传的图书 orgid为0是系统内置的图书
      if (!this.$store.getters.roles.includes("admin")) {
        if (item.orgid == 0) {
          // 系统内置
          return this.$message.info("非管理员账号只能删除本机构下的图书!", 1)
        }
      }
      let _this = this
      this.$confirm({
        title: <div>确认删除该图书吗?</div>,
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        async onOk () {
          let { data: res } = await _this.$http.get(`/v1/books/delete`, {
            params: {
              id: item.id,
              userId: _this.$store.getters.id,
            },
          })
          console.log(res)

          if (res.code != 200) return _this.$message.error(res.message)
          let index = _this.bookList.findIndex((sItem) => {
            return sItem.id == item.id
          })
          if (index != undefined || index != "undefined") {
            _this.bookList.splice(index, 1)
          }
          if (_this.bookList.length == 0 && _this.pagination.page > 1) {
            _this.pagination.page -= 1
          }
          _this.getBooklist()
          _this.$message.success(res.message, 1)
        },
        onCancel () {
          console.log("Cancel")
        },
      })
    },
  },
  created () {
    this.classMasterInfoList = this.$store.getters.classMasterInfoList || []
    this.getAllselect()
  },

  mounted () { },

  // keepalive页面第一次进入的时候
  activated () {
    console.log("activated,进来")
    console.log(this.$route)

    this.$emit("changeSelectKey", this.$route)
    this.getBooklist()
  },

  deactivated () {
    console.log("deactivated,清除")
  },
}
</script>

<style scoped lang="less">
.books {
  position: relative;
  min-height: calc(100vh - 14vh - 30px);
  height: calc(100vh - 14vh - 30px);
  overflow: auto;
}

.bookTerm {
  padding: 20px 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.bookTerm > div {
  // padding-bottom: 0.8em;
  // margin-bottom: 0.8em;
  // border-bottom: 1px dashed #ccc;
  margin-right: 2em;
  flex: 1;
}
.bookTerm > div.stage,
.bookTerm > div.grade {
  flex: 2;
}

.bookTerm > div:last-of-type {
  text-align: right;
}
.bookTerm-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.bookTerm-content > div {
  width: 25%;
}
.teach-list {
  margin: 20px 0 0 20px;
  min-height: 460px;
}
.teach-list > ul {
  overflow: hidden;
}
.teach-list > ul .lifirstAdd {
  height: 212px;
  line-height: 196px;
  border: 1px dashed #ddd;
  cursor: pointer;
  text-align: center;
}

.teach-list > ul .books-tip {
  position: relative;
  overflow: hidden;
}
.teach-list > ul .books-tip .books-tip-item {
  width: 15em;
  padding: 0.2em 0;
  text-align: center;
  position: absolute;
  right: -68px;
  top: 5%;
  color: #fff;
  transform: rotate(45deg);
  font-size: 12px;
}
.teach-list > ul > li {
  float: left;
  margin: 0 1% 15px 0;
  border: 1px solid #eee;
  width: 15.6%;
  min-height: 122px;
  cursor: pointer;
}
.teach-list > ul > li:hover {
  border-color: rgba(0, 0, 0, 0.09);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
}
.teach-list > ul > li img {
  width: 100%;
  height: 160px;
}

.teach-list > ul > li .dv1 {
  padding: 10px 0 10px 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.teach-list > ul > li .dv1 > span {
  /* width: 20%; */
}

.teach-list > ul > li .dv1 i {
  font-weight: bold;
  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
}
.teach-list > ul > li .dv1 > span .ant-dropdown-link {
  color: #000;
  font-size: 1.5em;
}

.teach-list > ul > li .dv1 > span .edit {
  display: inline-block;
  padding: 0 10px;
  color: #1890ff;
}

.teach-list > ul > li .dv1 > span .del {
  display: inline-block;
  padding: 0 10px;
  color: #ff4d4f;
}

.roles-waitch {
  margin-left: 0.5em;
  // display: inline-block;
  // height: 2em;
  // line-height: 2em;
}

.pagination {
  // position: absolute;
  // bottom: 10px;
  // left: 10px;
  margin: 15px;
}
</style>
